<script setup lang="ts">
import {
  TriangleAlert,
} from "@lucide/vue";

defineProps<{
  message: string;
}>();
</script>

<template>
  <div class="flex flex-col items-center gap-5 px-4 py-6 text-center">
    <div class="relative flex justify-center">
      <div class="absolute inset-0 animate-pulse rounded-full bg-red-500/25 blur-xl" />
      <div class="relative flex h-20 w-20 items-center justify-center rounded-full border border-red-200 bg-gradient-to-br from-orange-50 to-red-100 text-red-600 dark:border-red-900/70 dark:from-orange-950/50 dark:to-red-950/70 dark:text-red-300">
        <TriangleAlert class="h-10 w-10" />
      </div>
    </div>

    <p class="max-w-md text-base leading-relaxed text-slate-700 dark:text-slate-300">
      {{ message }}
    </p>
  </div>
</template>
